<script setup lang="ts"></script>

<template>
  <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round">
    <rect x="4" y="13" width="16" height="8" rx="1" />
    <line x1="12" y1="17" x2="12" y2="17" stroke-width="2" />
    <line x1="8" y1="10" x2="16" y2="10" />
    <line x1="7" y1="13" x2="7" y2="10" />
    <line x1="17" y1="13" x2="17" y2="10" />
  </svg>
</template>